export default "__VITE_ASSET__CsfYkXly__"